
(function ($) {
  const banner = document.getElementById('banner');
  const bannerbox = document.getElementById('banner-box');
  const iframeContainer = document.getElementById('iframe-container');
  const iframeClose = document.querySelector('.iframe-close');
  const aiimgClose = document.querySelector('.aiimg-close');
  let isDragging = false;

  iframeClose.addEventListener('click', () => {
    iframeContainer.style.display = 'none';
    banner.style.display = 'block';
  });
  aiimgClose.addEventListener('click', () => {
   bannerbox.style.display = 'none';
   
  });
  interact('#banner-box').draggable({
    inertia: true,
    modifiers: [
      interact.modifiers.restrictRect({
        restriction: 'parent',
        endOnly: true
      })
    ],
    listeners: {
      start(event) {
        isDragging = true;
        event.preventDefault();
      },
      move(event) {
        const target = event.target;
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

        target.style.transition=`none`;
        target.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      },
      end(event) {
        setTimeout(() => {
          isDragging = false;
        }, 100);
      }
    }
  });


  banner.addEventListener('click', function () {
    if (!isDragging) {
      iframeContainer.style.display = 'block';
      banner.style.display = 'none';
    }
  });


  document.addEventListener('touchmove', function (e) {
    if (isDragging) {
      e.preventDefault();
    }
  }, { passive: false });
})(jQuery);
